module.exports = __webpack_public_path__ + "img/bop-insurance.883ea390.png";